import './style';
import App from './components/app';

export default App;
// working in node: 14.17.4
// move to node: 14.18.0